import React, { useEffect, useState } from "react";
import { CollaboratorOption } from "../Collaborators/types";
import {
  CollaboratorsSelection,
  PlusContainer,
  SelectionContainer,
  StyledDropDown,
} from "../Collaborators/CollaboratorsStyledComponents";
import { getSelectedCollaboratorsAvatars } from "../Collaborators/getSelectedCollaboratorsAvatars";

export function EditSubtaskCollaborators({
  currentCollaborators,
  allCollaboratorsOptions,
  updateServiceFromWorkflow,
  serviceId,
  editMode = true,
}: {
  updateServiceFromWorkflow: (collaboratorOptions: CollaboratorOption[]) => any;
  allCollaboratorsOptions: CollaboratorOption[];
  currentCollaborators: CollaboratorOption[];
  serviceId: string;
  editMode: boolean;
}): JSX.Element {
  const [hideCollaborators, setHideCollaborators] = useState(true);
  const [selectedCollaborators, setCollaborators] = useState<
    CollaboratorOption[]
  >(currentCollaborators || []);
  useEffect(() => {
    setCollaborators(currentCollaborators);
  }, [serviceId]);

  const unselectedOptions = allCollaboratorsOptions.filter(
    (a) => !selectedCollaborators.find((s) => s.value.id === a.value.id)
  );
  const onSelectBlur = () => {
    if (!hideCollaborators) {
      setHideCollaborators(true);
    }
    return updateServiceFromWorkflow(selectedCollaborators);
  };
  return (
    <CollaboratorsSelection
      spread={!hideCollaborators}
      editMode={editMode}
      onClick={() => {
        if (editMode) setHideCollaborators(false);
      }}
    >
      {hideCollaborators ? (
        <SelectionContainer>
          {getSelectedCollaboratorsAvatars(selectedCollaborators)}
          {editMode && <PlusContainer>+</PlusContainer>}
        </SelectionContainer>
      ) : (
        <StyledDropDown
          autoFocus
          onBlur={onSelectBlur}
          options={unselectedOptions}
          isMulti
          onChange={(e: CollaboratorOption[]) => {
            setCollaborators(e ?? []);
          }}
          value={selectedCollaborators}
        />
      )}
    </CollaboratorsSelection>
  );
}
